import { render, staticRenderFns } from "./RequestNotificationList.vue?vue&type=template&id=dee3c508&"
import script from "./RequestNotificationList.vue?vue&type=script&lang=ts&"
export * from "./RequestNotificationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports